import { render, staticRenderFns } from "./CmgKebabMenu.vue?vue&type=template&id=0b495d38&scoped=true&lang=pug&"
import script from "./cmg-kebab-menu.ts?vue&type=script&lang=ts&"
export * from "./cmg-kebab-menu.ts?vue&type=script&lang=ts&"
import style0 from "./CmgKebabMenu.vue?vue&type=style&index=0&id=0b495d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b495d38",
  null
  
)

export default component.exports